export default __webpack_public_path__ + "static/media/Mark-2-HUD-Weather Map.18541e36.jpg";